import { render, staticRenderFns } from "./EmployerList.vue?vue&type=template&id=05f5befb&scoped=true"
import script from "./EmployerList.vue?vue&type=script&lang=js"
export * from "./EmployerList.vue?vue&type=script&lang=js"
import style0 from "./EmployerList.vue?vue&type=style&index=0&id=05f5befb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f5befb",
  null
  
)

export default component.exports